import { useEffect } from "react"
import type { SourceMetricIdsChangeHandler } from "connected-components/asset-view/hooks/use-source-displayed-metric-ids"

interface UseSourceGraphMetricIdsParams {
  itemIds: string[] | null
  onMetricsChange?: SourceMetricIdsChangeHandler
}

export function getEnabledItemIds<T extends { id: string, disabled: boolean }>(items: T[]): string[] {
  return items.filter((item) => !item.disabled).map((item) => item.id)
}

export function useSourceGraphMetricIds({ itemIds, onMetricsChange }: UseSourceGraphMetricIdsParams) {
  useEffect(() => {
    if (!onMetricsChange) return
    onMetricsChange(itemIds)
    return () => onMetricsChange(null)
  }, [itemIds, onMetricsChange])
}
